import {getGoogleOauthToken, getGoogleDownloadApi} from '@/api/authorization'
export const  GoogleAuthorization = {
  data () {
    return {
      file_id_payload:null,
      tempAttachments: [],
      attachments: [],
      pickerApiLoaded: false,
      developerKey: 'AIzaSyCuEqG-DOb0rcERq8cyfM8o3ff1N8pvLvU',
      clientId: '612289658344-g1145dqbp662bjbcd4v68k6blh99gmqd.apps.googleusercontent.com',
      scope: 'https://www.googleapis.com/auth/drive.readonly',
      oauthToken: null,
      folder_name: ''
    }
  },
  mounted () {
    const gDrive = document.createElement('script')
    gDrive.setAttribute('type', 'text/javascript')
    gDrive.setAttribute('src', 'https://apis.google.com/js/api.js')
    document.head.appendChild(gDrive)
  },
  methods: {
    // function called on click of drive icon
    async driveIconClicked (folderName) {
      try {
        this.folder_name = folderName
        const customer_id = localStorage.getItem('customer_id')
        const {data} = await getGoogleOauthToken(customer_id)
        this.oauthToken = data.data.access_token.access_token
        
        gapi.load('picker', () => {
          this.pickerApiLoaded = true
          this.createPicker()
        })

      } catch (error) {
        if (error.data.message === 'refresh token must be passed in or set as part of setAccessToken') {
          this.showSuccessMessage('Error', 'Need to authorize', 'danger')
        } else {
          this.showSuccessMessage('Error', error.data.message, 'danger')


        }
      }     
      /* await gapi.load('auth2', () => {
        gapi.auth2.authorize(
          {
            client_id: this.clientId,
            scope: this.scope,
            immediate: false
          },
          this.handleAuthResult
        )
      })
      gapi.load('picker', () => {
        this.pickerApiLoaded = true
        this.createPicker()
      }) */
    },

    handleAuthResult (authResult) {
      if (authResult && !authResult.error) {
        this.oauthToken = authResult.access_token
        this.createPicker()
      }
    },

    // Create and render a Picker object for picking user Photos.
    createPicker () {
      if (this.pickerApiLoaded && this.oauthToken) {
        const picker = new google.picker.PickerBuilder()
          .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
          .addView(google.picker.ViewId.DOCS)
          .setOAuthToken(this.oauthToken)
          .setDeveloperKey('AIzaSyCuEqG-DOb0rcERq8cyfM8o3ff1N8pvLvU')
          .setCallback(this.pickerCallback)
          .build()
        picker.setVisible(true)
      }
    },
    async pickerCallback (data) {
      let url = 'nothing'
      let name = 'nothing'
      if (data[google.picker.Response.ACTION] === google.picker.Action.PICKED) {
        const doc = data[google.picker.Response.DOCUMENTS][0]
        url = doc[google.picker.Document.URL]
        name = doc.name
        const docs = data.docs
        const param = { fileId: doc.id, oAuthToken: this.oauthToken, name }
        const attachments = []
        for (let i = 0; i < docs.length; i++) {
          const attachment = {}
          attachment._id = docs[i].id
          attachment.title = docs[i].name
          attachment.name = `${docs[i].name  }.${  docs[i].mimeType.split('/')[1]}`
          attachment.type = 'gDrive'
          attachment.description = 'Shared with GDrive'
          attachment.extension =
            `.${ 
              docs[i].mimeType.substring(docs[i].mimeType.lastIndexOf('.') + 1)}`
          attachment.iconURL = docs[i].iconUrl
          attachment.size = docs[i].sizeBytes
          attachment.user = JSON.parse(localStorage.getItem('user'))
          attachment.thumb = null
          attachment.thumb_list = null
          attachment.embedUrl = docs[i].embedUrl
          attachment.url = docs[i].url
          /*   this.fileRecordsForUpload.push({'file': {},
            'urlResized': docs[i].url,
            'lastModified': 1625232639094,
            'sizeText': '36 KB',
            'size': attachment.size,
            'type': docs[i].mimeType,
            'ext': attachment.extension,
            'color': 'rgb(255, 255, 255)',
            'upload': {
              'data': null,
              'error': false
            }
          }) */
          // attachments.push(attachment)
          // this.getGoogleDownload(docs[i])
          /*  if (attachment.size === 0) {
            this.showSuccessMessage('Error', 'this files cant be uploaded', 'danger')
          } else {
            this.getGoogleDownload(docs[i])

          } */
        }

        if ((this.multipleSelect) || (!this.multipleSelect && docs.length === 1)) {
          const checkingInvalidFormat = docs.some(ele => {

            if (ele.sizeBytes !== 0) {
              if (this.fileTypeValidation && ele.type !== this.fileTypeValidation) {
                return true
              }

              if (this.fileSizeValidation && ele.sizeBytes > this.fileSizeValidation) {
                return true
              }
            } else {
              return true
            }
          })

          if (checkingInvalidFormat) {
            this.showSuccessMessage('Error', 'this files cant be uploaded', 'danger')
  
          } else {
            this.getGoogleDownload(docs)
  
          }

        } else {
          this.showSuccessMessage('error', 'Only Single Select is Allowed', 'danger')

        }
       

        this.tempAttachments = [...attachments]
      }
      // this.oauthToken = null;
      this.pickerApiLoaded = false
    },
    async getGoogleDownload (docs) {
      try {
        const payload = { 
          files:docs,
          folder_name: this.folder_name
        }
        const customer_id = localStorage.getItem('customer_id')
        this.$vs.loading({text:'Please wait while we are uploading the file'})
        const {data} = await getGoogleDownloadApi(customer_id, payload)
        const file_array = data.data.files.map(ele => {
          return {
            file_name:ele.file_name,
            file_path: `${data.data.cdn}${ele.file_path}`
          }
        })
        const raw = JSON.stringify({
          file_repository_id: this.file_repository_id,
          files: file_array
        })

        const file_id_payload = raw

        this.file_id_payload = {
          file_repository_id: this.file_repository_id,
          files: file_array
        }

        this.getUploadFiles(file_id_payload, 'drive')
        if (this.folder_name === 'Files') {
          this.fetchDetailsFromFolder()
        }
      } catch (error) {
        console.warn(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    checkingOnlyImage (docs) {
      return docs.every(ele => ele.mimeType.split('/')[0] === 'image')
    }
  },
 
  computed: {
    getTempAttachments () {
      return this.tempAttachments
    },
    getAttachments () {
      return this.attachments
    }
  }
}